import React, { useContext, useEffect, useState } from 'react';
import { IoIosCart } from "react-icons/io";
import CartMessage from '../CartMessage';
import CartData from '../CartData';
import CartSummary from '../CartSummary';
import CartButton from '../CartButton';
import { filterDataContext } from '../../../../App';
import { PAY_DETAILS_API_INTEGRATION, RESERVE_AGAIN_API } from '../../../../APIs';
import PriceIncreasePopUp from '../../../PriceIncreasePopUp';
import CustomModal from '../../../CustomModal';
import QuantityCheckPopUp from '../../../QuantityCheck';
import { useLocation, useNavigate } from 'react-router-dom';
import { CHECKOUTPAGE, PRE_CHECKOUTPAGE } from '../../../../constants/RoutingPath';

const Cart = ({ fetchCartList, closeFuncState, markupDetails , checkoutPage , setOrderTotalValue , orderTotalValue }) => {
  const { cartData, setCartData, setReserVationData, bookingData, timeRemaining, stockAvailabilitydata, setTimeRemaining, cartValidUntil, checkoutReserVationId, setStockAvailabilityData, reservationData, setNewReservationExpiredMsg, setCheckoutReservationId } = useContext(filterDataContext)
  const [categorisedData, setCategorisedData] = useState([])
  const [payDetailInfo, setPayDetailInfo] = useState({})
  const [isPriceChangeModal, setIsPriceChangeModal] = useState(false)
  const [priceChangeTicketData, setPriceChangeTicketData] = useState([])
  const [showQuantityUpdatePopUp, setShowQuantityUpdatePopUp] = useState(false)
  const [filtereQuantityCheckData, setFilteredQuantityCheckData] = useState([])
  const [convertedGuestPayload, setConvertedPayload] = useState([])
  const [isAPiLoading, setIsAPiLoading] = useState(false)


  const location = useLocation()
  const navigate = useNavigate()

  const transformGuestData = (guests) => {
    return guests.map(({ lead_guest, activeGuest, ...rest }) => {
      const transformedGuest = { lead_guest, activeGuest };
      Object.keys(rest).forEach((key) => {
        transformedGuest[key] = {
          error: null,
          value: rest[key] || null,
        };
      });

      return transformedGuest;
    });
  };

  useEffect(() => {
    const convertedData = bookingData?.BookingData?.map((item) => {
      let data = [];

      item?.tickets?.forEach((guestData) => {
        if (guestData?.guestDetail) {
          data.push({
            quantity: guestData?.guestDetail?.quantity,
            ticket_id: guestData?.guestDetail?.ticket_id,
            guests: transformGuestData(guestData?.guests)
          });
        }
      });
      return data;
    });
    if (convertedData?.length > 0) {
      setConvertedPayload(convertedData)
    }
  }, [bookingData]);


  useEffect(() => {
    if (cartData?.length > 0 && stockAvailabilitydata?.length > 0) {
      function getTicketsWithErrorsAndDetails(ticketsArray1, ticketsArray2) {
        return ticketsArray1.reduce((acc, details) => {
          const errorData = ticketsArray2.find(error => error.ticket_id === details.ticket_id);
          if (errorData) {
            acc.push({ details, error: errorData });
          }
          return acc;
        }, []);
      }
      const filteredData = getTicketsWithErrorsAndDetails(cartData, stockAvailabilitydata);
      console.log(filteredData , "filteredDatafilteredData")
      if (filteredData?.length > 0) {
        setShowQuantityUpdatePopUp(true)
        setFilteredQuantityCheckData(filteredData)
      } else {
        setShowQuantityUpdatePopUp(false)
        setFilteredQuantityCheckData([])
      }
    }
  }, [stockAvailabilitydata, cartData])

  useEffect(() => {
    if (checkoutReserVationId) {
      fetchPayDetailInfo(checkoutReserVationId)
    }
  }, [checkoutReserVationId])

  const groupedTickets = (data) => {
    let groupedCategories = {};
    data?.forEach((item) => {
      const { event_event } = item;
      if (groupedCategories[event_event.event_name]) {
        groupedCategories[event_event.event_name].push(item);
      } else {
        groupedCategories[event_event.event_name] = [item];
      }
    });
    setCategorisedData(groupedCategories);
  };

  useEffect(() => {
    function filterTicketsByPriceNotification(data) {
      let filteredData = {};
      Object.keys(data).forEach((match) => {
        let filteredTickets = data[match].filter(ticket => (ticket?.priceNotification !== null && (ticket?.priceNotification?.isIncressPrice === true || ticket?.priceNotification?.isDecressPrice === true)));
        if (filteredTickets?.length > 0) {
          filteredData[match] = filteredTickets;
        }
      });
      return filteredData;
    }
    if (categorisedData) {
      const data = filterTicketsByPriceNotification(categorisedData)
      if (Object.keys(data).length > 0) {
        setPriceChangeTicketData(data)
        setIsPriceChangeModal(true)
      } else {
        setIsPriceChangeModal(false)
        setPriceChangeTicketData([])
      }
    }
  }, [categorisedData])


  const closePopUp = (func) => {
    func();
  };

  const fetchPayDetailInfo = async (id) => {
    try {
      const response = await PAY_DETAILS_API_INTEGRATION(id)
      if (response && response?.status) {
        if(checkoutPage){
          setOrderTotalValue(response?.data?.total?.sub_total)
        }
        setPayDetailInfo(response?.data)
      }
    } catch (error) {
      console.log(error, "payDetailInfo")
    }
  }

  useEffect(() => {
    if (cartData) {
      groupedTickets(cartData)
    }
  }, [cartData])

  const handleReserveAgain = async (data) => {
    try {
      setStockAvailabilityData([])
      setNewReservationExpiredMsg("")
      setIsAPiLoading(true)
      setCheckoutReservationId("")
      const payload = {
        items: data? data :  reservationData,
        isNew: true,
        oldReservationId: checkoutReserVationId,
        temp_guest_info: convertedGuestPayload?.[0]
      }
      const response = await RESERVE_AGAIN_API(payload)
      if (response && response.status) {
        setCheckoutReservationId(response?.data?.reservation_id)
        if (location.pathname !== CHECKOUTPAGE && location.pathname !== PRE_CHECKOUTPAGE) {
          fetchCartList()
        }
        if (location.pathname === "/checkout") {
          navigate(PRE_CHECKOUTPAGE)
        }
      } else {
        setCheckoutReservationId(payload?.oldReservationId)
        if (response?.statusCode === 422) {
          setStockAvailabilityData(response?.data?.items)
        }
        if (response?.message === "Reservation has expired, you will have to start a new one.") {
          setNewReservationExpiredMsg(response?.message)
        }
      }
    } catch (error) {
      console.log("RESERVE_AGAIN", error)
    } finally {
      setIsAPiLoading(false)
    }
  }

  return (
    <>
      {
        isPriceChangeModal &&
        <CustomModal
          closeFunc={closePopUp}
          closeFuncState={setIsPriceChangeModal}
          children={
            <PriceIncreasePopUp cartData={priceChangeTicketData} setState={setIsPriceChangeModal} />
          }
        />
      }

      {
        showQuantityUpdatePopUp &&
        <CustomModal
          closeFunc={closePopUp}
          closeFuncState={setShowQuantityUpdatePopUp}
          children={
            <QuantityCheckPopUp data={filtereQuantityCheckData}
              setState={setShowQuantityUpdatePopUp}
              handleReserveAgain={handleReserveAgain}
            />
          }
        />
      }

      <div className="cart-popup" style={{ padding: checkoutPage ? "0" : "2rem", maxWidth: checkoutPage ? "initial" : "800px" }} >


        {
          !checkoutPage &&
          <div className="cart-header">
            <h2> <IoIosCart width={25} height={25} /> Shopping Cart</h2>
          </div>
        }
        {cartData?.length > 0 ?
          <>
            <CartMessage setTimeRemaining={setTimeRemaining} cartValidUntil={cartValidUntil} msg={`The contents of your cart are reserved for you. Time remaining: ${timeRemaining}`} timeRemaining={timeRemaining} checkoutPage={checkoutPage ? true : false} fetchCartList={fetchCartList} convertedGuestPayload={convertedGuestPayload} handleReserveAgain={handleReserveAgain} isAPiLoading={isAPiLoading} />
            <div className={`cart_info ${checkoutPage ? "checkout_cart" : "popUp_cart"}`}   >

              {
                Object.entries(categorisedData).map(([eventName, tickets]) => {
                  return (
                    <CartData eventName={eventName} tickets={tickets} fetchCartList={fetchCartList} />
                  )
                })
              }
            </div>

            <CartSummary payDetailInfo={payDetailInfo} markupDetails={markupDetails} />
            {
              !checkoutPage &&
              <CartButton fetchCartList={fetchCartList} setCartData={setCartData} setReserVationData={setReserVationData} closeFuncState={closeFuncState} timeRemaining={timeRemaining}/>
            }
          </>
          :
          <CartMessage msg={"There are no items in your shopping cart right now..."} />
        }
      </div>
    </>
  )
}

export default React.memo(Cart);